module.exports = __webpack_public_path__ + "img/time_icon.0ad7f4e5.svg";